export default {
  giftAmount: {
    id: 'gift_cards_results_gift_amount',
    defaultMessage: 'Gift amount: {price}',
  },
  validUntil: {
    id: 'gift_cards_results_valid_until',
    defaultMessage: 'Valid until {expiresAt}',
  },
  copySuccessToastTitle: {
    id: 'gift_cards_results_copy_success_toast_title',
    defaultMessage: 'Copied!',
  },
}
